import { z } from 'zod';

export const schema = z.object({
  email: z.string().min(1, { message: 'required' }),
  password: z.string().min(1, { message: 'required' }),
});

export type FormLogin = z.infer<typeof schema>;
